import React, { useMemo, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { Box, Tabs, TabPanel } from 'components';
import { RootState } from 'redux-modules/store/rootState';
// import Settings from 'views/Settings';
// import ComingSoon from 'components/ComingSoon';

import BasicDetails from './components/BasicDetails';
import Documents from './components/Documents';
import ProfileKycDetail from './components/ProfileKycDetail';
import styles from './styles';

type handleParams = {
  tab: string;
};

const Profile = () => {
  const classes = styles();
  const { tab } = useParams<handleParams>();

  const spv = 'PROFILE';
  const tabsForMenu = ['basic-details', 'kyc', 'settings', 'document'];
  const [value, setValue] = useState<number>(
    !isEmpty(tab) ? tabsForMenu.indexOf(tab) : 0,
  );

  const { investor } = useSelector(({ Investor }: RootState) => Investor);

  const { investorKyc } = investor;
  const kycDetail = investorKyc?.find((kyc: any) => kyc.spv === spv);

  const tabs = useMemo(() => {
    const tabsList = [
      { name: 'Basic Details', key: 'BASIC_DETAILS' },
      { name: 'KYC', key: 'KYC' },
      // { name: 'Settings', key: 'SETTINGS' },
      { name: 'Documents', key: 'DOCUMENTS' },
    ];

    return tabsList;
  }, []);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box className={classes.profileBox}>
      <Box className={classes.mainHeader}>
        <Typography className={classes.mainHeaderText}>Profile</Typography>
      </Box>
      <Box className={classes.profileCont}>
        <Tabs
          tabs={tabs}
          value={value}
          handleChange={handleChange}
          className={classes.tabsContainer}
        />
        <TabPanel value={value} index={0}>
          <Box className={classes.tabPanelContainer}>
            <BasicDetails investor={investor} />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box className={classes.tabPanelContainer}>
            <ProfileKycDetail
              spv={spv}
              investor={investor}
              kycDetail={kycDetail}
            />
          </Box>
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
          <Box className={classes.tabPanelContainer}>
            <Settings />
            <ComingSoon />
          </Box>
        </TabPanel> */}
        <TabPanel value={value} index={2}>
          <Box className={classes.tabPanelContainer}>
            <Documents />
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};
export default Profile;
